import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';
import { POST_GROUP_EXAM_REGISTRATION_SUMMARY_PDF_URL } from '../../constants/apiUrls';

// =============================================================================
// Request & Response Model
// =============================================================================

interface PostGroupExamRegistrationSummaryPDFRequest {
  applicationUuid: string;
}

interface PostGroupExamRegistrationSummaryPDFResponse {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PostGroupExamRegistrationSummaryPDFResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePostGroupExamRegistrationSummaryPDF = ({
  onSuccess,
  onError,
  onSettled,
}: Input) => {
  const postGroupExamRegistrationSummaryPDF = async (
    payload: PostGroupExamRegistrationSummaryPDFRequest
  ) => {
    const res = await axiosClient.post<PostGroupExamRegistrationSummaryPDFResponse>(
      POST_GROUP_EXAM_REGISTRATION_SUMMARY_PDF_URL(payload.applicationUuid)
    );
    return res.data;
  };

  return useCustomMutation(postGroupExamRegistrationSummaryPDF, {
    onSuccess,
    onError,
    onSettled,
  });
};
